<template>
  <div/>
</template>

<script>
export default {
  name: 'ConfigurationAccountsBC',
  props: {
    value: {type:Object, required:true},
    accounts: {type:Array, required:true}
  }
}
</script>